<template>
  <section
    class="my-8 mx-auto bg-black pt-6 px-2 md:px-10 pb-5 font-bold shadow-black shadow-xl divide-y-2 divide-white max-w-[1400px]"
  >
    <RallyLogoDownload link-text="Download Rally Navigator" />
    <div class="my-4 pt-4">
      <h1 class="text-white font-russo text-2xl md:text-3xl font-normal">
        RALLY ROADBOOK READER &#8211; MOBILE APP
      </h1>
      <h2 class="text-[#999999] font-helvetica text-[19px]">
        View and Navigate Roadbooks from Rally Navigator
      </h2>
      <div
        class="grid grid-rows-3 md:grid-rows-1 md:grid-cols-3 gap-0 md:gap-12 items-center py-2 md:py-8"
      >
        <a
          href="https://apps.apple.com/us/app/rally-roadbook-reader/id1440988194"
        >
          <picture class="contents">
            <source srcset="/images/Subscriptions/AppStoreLogo.webp" type="image/webp" />
            <img
            decoding="async"
            width="250"
            height="76"
            src="/images/Subscriptions/AppStoreLogo.jpg"
            class="flex m-auto"
            alt="Download Rally Roadbook Reader on the Apple App Store"
            />
          </picture>
        </a>
        <picture class="contents">
          <source srcset="/images/New-Reader-Icon.webp" type="image/webp" />
          <img
          decoding="async"
          fetchpriority="high"
          width="250"
          height="250"
          src="/images/New-Reader-Icon.png"
          class="flex m-auto"
          alt="Rally Roadbook Reader app icon"
          />
        </picture>
        <a
          href="https://play.google.com/store/apps/details?id=com.rallynavigator.rallyroadbookreader&amp;rdid=com.rallynavigator.rallyroadbookreader&amp;pli=1"
        >
          <picture class="contents">
            <source srcset="/images/google-Play-store-logo.webp" type="image/webp" />
            <img
            decoding="async"
            width="250"
            height="76"
            src="/images/google-Play-store-logo.jpg"
            class="flex m-auto"
            alt="Get Rally Roadbook Reader on Google Play"
            />
          </picture>
        </a>
      </div>
      <h2 class="text-white font-helvetica text-[24px] font-bold">
        DIGITAL ROADBOOK &#8211; ADJUSTABLE ODOMETER &#8211; CAP HEADING
      </h2>
      <h2 class="text-[#999999] font-helvetica text-[24px] font-semibold pt-4">
        SHARE ROADBOOKS WITH INDIVIDUALS AND GROUPS
      </h2>
    </div>
    <div class="pt-8">
      <div class="grid grid-rows-2 md:grid-rows-1 md:grid-cols-2 gap-8 m-auto">
        <picture class="contents">
          <source srcset="/images/Rally-Roadbook-Reader-Cross-Country-qbqkj0ew3uhsg00vhekfwcv2rbul6chfmx0xel4uks.webp" type="image/webp" />
          <img width="350" height="750"
          decoding="async"
          src="/images/Rally-Roadbook-Reader-Cross-Country-qbqkj0ew3uhsg00vhekfwcv2rbul6chfmx0xel4uks.png"
          title="Rally Roadbook Reader Cross Country"
          alt="Rally Roadbook Reader Cross Country"
          loading="lazy"
          class="flex m-auto"
          />
        </picture>
        <picture class="contents">
          <source srcset="/images/Rally-Roadbook-Reader-Road-Rally-qbqkj0ew3uhsg00vhekfwcv2rbul6chfmx0xel4uks.webp" type="image/webp" />
          <img width="350" height="750"
          decoding="async"
          src="/images/Rally-Roadbook-Reader-Road-Rally-qbqkj0ew3uhsg00vhekfwcv2rbul6chfmx0xel4uks.png"
          title="Rally Roadbook Reader Road Rally"
          alt="Rally Roadbook Reader Road Rally"
          loading="lazy"
          class="flex m-auto"
          />
        </picture>
      </div>
      <div
        class="grid grid-cols-2 md:grid-cols-4 gap-2 m-auto py-12 px-4 md:px-24"
      >
        <picture class="contents">
          <source srcset="/images/IMG_07918c62-scaled-qbqkj0eua28kybqzcp7mc9chh0i8g7rj4jex261mu4.webp" type="image/webp" />
          <img width="200" height="150"
          decoding="async"
          src="/images/IMG_07918c62-scaled-qbqkj0eua28kybqzcp7mc9chh0i8g7rj4jex261mu4.jpg"
          title="IMG_07918c62"
          alt="IMG_07918c62"
          loading="lazy"
          class="flex m-auto"
          />
        </picture>
        <picture class="contents">
          <source srcset="/images/IMG_0789-Copy-scaled-qbqkj0eua28kybqzcp7mc9chh0i8g7rj4jex261mu4.webp" type="image/webp" />
          <img width="200" height="150"
          decoding="async"
          src="/images/IMG_0789-Copy-scaled-qbqkj0eua28kybqzcp7mc9chh0i8g7rj4jex261mu4.jpg"
          title="IMG_0789 &#8211; Copy"
          alt="IMG_0789 - Copy"
          loading="lazy"
          class="flex m-auto"
          />
        </picture>
        <picture class="contents">
          <source srcset="/images/IMG_0800-Copy-scaled-qbqkj0eua28kybqzcp7mc9chh0i8g7rj4jex261mu4.webp" type="image/webp" />
          <img width="200" height="150"
          decoding="async"
          src="/images/IMG_0800-Copy-scaled-qbqkj0eua28kybqzcp7mc9chh0i8g7rj4jex261mu4.jpg"
          title="IMG_0800 &#8211; Copy"
          alt="IMG_0800 - Copy"
          loading="lazy"
          class="flex m-auto"
          />
        </picture>
        <picture class="contents">
          <source srcset="/images/IMG_0806-Copy-scaled-qbqkj0eua28kybqzcp7mc9chh0i8g7rj4jex261mu4.webp" type="image/webp" />
          <img width="200" height="150"
          decoding="async"
          src="/images/IMG_0806-Copy-scaled-qbqkj0eua28kybqzcp7mc9chh0i8g7rj4jex261mu4.jpg"
          title="IMG_0806 &#8211; Copy"
          alt="IMG_0806 - Copy"
          loading="lazy"
          class="flex m-auto"
          />
        </picture>
      </div>
    </div>
    <div class="py-8">
      <h2
        class="text-[#FF0000] font-russo text-[22px] md:text-[28px] font-black"
      >
        RALLY ROADBOOK READER APP
      </h2>
      <ul
        class="text-[#A9A9A9] font-arial text-[17px] font-semibold mt-4 items-center flex flex-col gap-4"
      >
        <li>
          <p>
            Share and Import PDF Roadbooks via email, text, Google Drive, My
            Files, Drop Box Etc.
          </p>
        </li>
        <li>
          <p>
            Create PDF Roadbook on Rally Navigator, then share and invite
            unlimited users to download app and view Roadbooks FREE
          </p>
        </li>
        <li><p>Create folders and organize Roadbooks on device</p></li>
        <li><p>Improved contrast of ODO and CAP Instruments</p></li>
        <li><p>Zoom and Lock Roadbook to proper width</p></li>
        <li><p>Adjustable Roadbook Scroll Distance</p></li>
        <li>
          <p>Swipe right on Odometer display to edit odometer distance</p>
        </li>
      </ul>
    </div>
    <div class="py-4">
      <h2 class="text-2xl md:text-3xl text-white font-russo">
        HOW ROADBOOK READER WORKS
      </h2>
      <h2 class="text-2xl md:text-3xl text-white font-russo">
        CLICK TO WATCH VIDEO
      </h2>
      <YouTubeEmbed
        class="m-auto my-8 w-[300px] h-[182px] md:w-[650px] md:h-[395px] lg:w-[896px] lg:h-[448px] border-white border-4"
        title="Rally Roadbook Reader - Mobile App for iOS and Android"
        src="https://www.youtube.com/embed/G80oQbie-2k"
        thumb="https://i.ytimg.com/vi/G80oQbie-2k/hqdefault.jpg"
      />
    </div>
    <div class="py-8">
      <h2 class="text-[#FF0000] font-russo text-[22px]">
        FEATURES &#038; FUNCTIONS
      </h2>
      <ul
        class="text-[#A9A9A9] font-helvetica text-[18px] font-semibold mt-4 items-center flex flex-col gap-4"
      >
        <li>
          <p>FULL DETAIL ROADBOOKS</p>
        </li>
        <li>
          <p>CROSS COUNTRY OR ROAD RALLY FORMAT</p>
        </li>
        <li>
          <p>CONTROL ODOMETER AND ROADBOOK SCROLLING WITH BLUETOOTH SWITCHES</p>
        </li>
        <li><p>PHONE IN LANDSCAPE VIEW WORKS AS RALLY COMPUTER</p></li>
        <li><p>ODOMETER - CAP HEADING - SPEED - TIME OF DAY</p></li>
      </ul>
      <picture class="contents">
        <source srcset="/images/Rally-Roadbook-Reader-Rally-Cockpit-qbqkj0exbp6khpofx5q3k53gx8mljfvuf72tq28sk6.webp" type="image/webp" />
        <img width="450" height="207"
        decoding="async"
        src="/images/Rally-Roadbook-Reader-Rally-Cockpit-qbqkj0exbp6khpofx5q3k53gx8mljfvuf72tq28sk6.png"
        title="Rally Roadbook Reader Rally Cockpit"
        alt="Rally Roadbook Reader Rally Cockpit"
        loading="lazy"
        class="m-auto pt-8"
        />
      </picture>
    </div>
    <ul class="grid grid-rows-3 md:grid-rows-1 md:grid-cols-3 gap-4 py-8">
      <li>
        <picture class="contents">
          <source srcset="/images/Splash-Screen.webp" type="image/webp" />
          <img
          decoding="async"
          loading="lazy"
          width="1125"
          height="2436"
          src="/images/Splash-Screen.jpg"
          class="attachment-full size-full wp-image-402"
          alt="Rally Roadbook Reader app splash screen"
          sizes="(max-width: 1125px) 100vw, 1125px"
          />
        </picture>
      </li>
      <li>
        <picture class="contents">
          <source srcset="/images/Rally-Roadbook-Reader-Splash-Screen-1.webp" type="image/webp" />
          <img
          decoding="async"
          loading="lazy"
          width="350"
          height="757"
          src="/images/Rally-Roadbook-Reader-Splash-Screen-1.jpg"
          class="attachment-full size-full wp-image-1395"
          alt="Rally Roadbook Reader app splash screen"
          sizes="(max-width: 350px) 100vw, 350px"
          />
        </picture>
      </li>
      <li>
        <picture class="contents">
          <source srcset="/images/Rally-Roadbook-Reader-My-Roadbooks.webp" type="image/webp" />
          <img
          decoding="async"
          loading="lazy"
          width="1125"
          height="2436"
          src="/images/Rally-Roadbook-Reader-My-Roadbooks.png"
          class="attachment-full size-full wp-image-422"
          alt="My Roadbooks list in the Rally Roadbook Reader app"
          sizes="(max-width: 1125px) 100vw, 1125px"
          />
        </picture>
      </li>
    </ul>
    <div class="py-8">
      <h2 class="text-[#FF0000] font-russo text-[22px]">
        HOW TO SHARE ROADBOOK TO THE APP?
      </h2>
      <ul
        class="text-[#A9A9A9] font-arial text-[17px] font-semibold mt-4 items-center flex flex-col gap-4"
      >
        <li>
          <p>Print a PDF Roadbook from Rally Navigator</p>
        </li>
        <li>
          <p>
            (Wide Roll x 1 Best for Cross Country - Legal Size Best for Road
            Rally)
          </p>
        </li>
        <li>
          <p>
            Roadbook will download to users local computer. PDF can be shared
            with users via email, text, hosting on web page for download, Google
            Drive, iCloud, social media, etc. However you like to share files.
          </p>
        </li>
        <li>
          <p>
            To load roadbooks into the app, users go to My Roadbooks folder and
            press "Import Roadbook +" and add Roadbooks to library from any
            source.
          </p>
        </li>
        <li>
          <p>Users can also share Roadbooks from Reader app to other users.</p>
        </li>
      </ul>
      <div
        class="grid grid-rows-2 md:grid-rows-1 md:grid-cols-2 m-auto gap-8 pt-16"
      >
        <picture class="contents">
          <source srcset="/images/Rally-Roadbook-Reader-Import-File-qbqkj0evhx3aep9v3wsmkriw1qio7ivze9zfbemr1g.webp" type="image/webp" />
          <img width="300" height="650"
          decoding="async"
          src="/images/Rally-Roadbook-Reader-Import-File-qbqkj0evhx3aep9v3wsmkriw1qio7ivze9zfbemr1g.png"
          title="Rally Roadbook Reader &#8211; Import File"
          alt="Rally Roadbook Reader - Import File"
          loading="lazy"
          class="flex m-auto md:ml-auto md:mr-0"
          />
        </picture>
        <picture class="contents">
          <source srcset="/images/Rally-Roadbook-Reader-Share-Roadbook-qbqkj0evhx3aep9v3wsmkriw1qio7ivze9zfbemr1g.webp" type="image/webp" />
          <img width="300" height="650"
          decoding="async"
          src="/images/Rally-Roadbook-Reader-Share-Roadbook-qbqkj0evhx3aep9v3wsmkriw1qio7ivze9zfbemr1g.png"
          title="Rally Roadbook Reader Share Roadbook"
          alt="Rally Roadbook Reader Share Roadbook"
          loading="lazy"
          class="flex m-auto md:mr-auto md:ml-0"
          />
        </picture>
      </div>
    </div>
    <div class="py-8 text-[#999999] font-helvetica">
      <h2 class="text-[22px] font-semibold">
        Bluetooth Roadbook Reader Controls
      </h2>
      <ul
        class="text-[18px] font-semibold mt-4 items-center flex flex-col gap-2"
      >
        <li>
          <p class="text-white">
            Volume Up/Volume Down adjust Odometer Up/Down
          </p>
        </li>
        <li>
          <p class="text-white">
            Next Track/Previous Track scroll Roadbook Up/Down
          </p>
        </li>
        <li>
          <p>Any Bluetooth Audio device will control Roadbook Reader app.</p>
        </li>
      </ul>
      <div class="grid grid-cols-2 m-auto gap-8 pt-16">
        <a href="http://www.modeo.co/shop/bluetooth-volume-control">
          <picture class="contents">
            <source srcset="/images/Bluetooth-Volume-Control-300x300.webp" type="image/webp" />
            <img
            decoding="async"
            loading="lazy"
            width="300"
            height="300"
            src="/images/Bluetooth-Volume-Control-300x300.jpg"
            alt="Bluetooth volume control for rally roadbook navigation"
            sizes="(max-width: 300px) 100vw, 300px"
            class="flex ml-auto mr-0"
            />
          </picture>
        </a>
        <a
          href="https://www.amazon.com/Bluetooth-Adapter-DDSKY-Steering-Controller/dp/B07NXQZNRS"
        >
          <picture class="contents">
            <source srcset="/images/51rPNr9NjcL._AC_SL1000_-269x300.webp" type="image/webp" />
            <img
            decoding="async"
            loading="lazy"
            width="269"
            height="300"
            src="/images/51rPNr9NjcL._AC_SL1000_-269x300.jpg"
            alt="Rally navigation phone mount accessory"
            sizes="(max-width: 269px) 100vw, 269px"
            class="flex mr-auto ml-0"
            />
          </picture>
        </a>
      </div>
      <h2 class="text-[#999999] text-[18px] font-semibold pt-8">
        Search Online for "Bluetooth Audio Control" and you will find many
        different solutions to control the Roadbook Reader app.
      </h2>
    </div>
    <div class="py-8 text-[#999999] font-helvetica">
      <h2 class="text-[22px] font-semibold">
        Higher Quality Motorcycle Options
      </h2>
      <div class="grid grid-cols-2 m-auto gap-8 pt-8">
        <a href="http://www.buttoner.lv/">
          <picture class="contents">
            <source srcset="/images/PIC07692__Large_-qbqkj0ewprszt270pnzzqqd78m64r0m0tc6zqls3nw.webp" type="image/webp" />
            <img width="400" height="270"
            decoding="async"
            src="/images/PIC07692__Large_-qbqkj0ewprszt270pnzzqqd78m64r0m0tc6zqls3nw.jpg"
            title="PIC07692__Large_"
            alt="PIC07692__Large_"
            loading="lazy"
            class="flex ml-auto mr-0"
            />
          </picture>
        </a>
        <a href="https://www.buttoner.lv/produkti/rally-serija/">
          <picture class="contents">
            <source srcset="/images/PIC07675-qbqkj0ewprszt270pnzzqqd78m64r0m0tc6zqls3nw.webp" type="image/webp" />
            <img width="400" height="270"
            decoding="async"
            src="/images/PIC07675-qbqkj0ewprszt270pnzzqqd78m64r0m0tc6zqls3nw.jpg"
            title="PIC07675"
            alt="PIC07675"
            loading="lazy"
            class="flex mr-auto ml-0"
            />
          </picture>
        </a>
      </div>
      <div class="pt-16">
        <a href="http://www.buttoner.lv/produkti/rally-serija/">
          <picture class="contents">
            <source srcset="/images/website_logo_transparent_background-1.webp" type="image/webp" />
            <img
            decoding="async"
            loading="lazy"
            width="300"
            height="110"
            src="/images/website_logo_transparent_background-1.jpg"
            class="flex m-auto"
            alt="Rally Navigator partner logo"
            />
          </picture>
        </a>
        <p class="text-[22px] font-bold text-[#FF0000] pt-4 text-center">
          <a href="http://www.buttoner.lv/"> Buttoner </a>
        </p>
      </div>
      <div class="grid grid-cols-2 m-auto gap-8 pt-8">
        <a
          href="http://rally.o2riders.com/en/prod/roadbook-bluetooth-remote-controller/"
        >
          <picture class="contents">
            <source srcset="/images/o2Rc-slim-600x375-1-qbqkj0ewprsvpqq5ug9i1b775uhahu7san3fc0h3us.webp" type="image/webp" />
            <img width="400" height="250"
            decoding="async"
            src="/images/o2Rc-slim-600x375-1-qbqkj0ewprsvpqq5ug9i1b775uhahu7san3fc0h3us.jpg"
            title="o2Rc-slim-600&#215;375"
            alt="o2Rc-slim-600x375"
            loading="lazy"
            class="flex ml-auto mr-0"
            />
          </picture>
        </a>
        <a href="https://rally.o2riders.com/en/electronic-roadbook/">
          <picture class="contents">
            <source srcset="/images/centralia-qbqkj0ewprsvpqq5ug9i1b775uhahu7san3fc0h3us.webp" type="image/webp" />
            <img width="400" height="250"
            decoding="async"
            src="/images/centralia-qbqkj0ewprsvpqq5ug9i1b775uhahu7san3fc0h3us.jpg"
            title="centralia"
            alt="centralia"
            loading="lazy"
            class="flex mr-auto ml-0"
            />
          </picture>
        </a>
      </div>
      <div class="pt-16">
        <a href="https://rally.o2riders.com/en/electronic-roadbook/">
          <picture class="contents">
            <source srcset="/images/O2-Riders.webp" type="image/webp" />
            <img
            decoding="async"
            loading="lazy"
            width="300"
            height="105"
            src="/images/O2-Riders.jpg"
            class="flex m-auto"
            alt="O2 Riders logo"
            />
          </picture>
        </a>
        <p class="text-[22px] font-bold text-[#FF0000] pt-4 text-center">
          <a href="http://www.buttoner.lv/"> Rally O2 Riders </a>
        </p>
      </div>
      <a href="http://jaxeadv.com/barbuttons/">
        <picture class="contents">
          <source srcset="/images/jaxeadv-logo-complete-and-transparent-300x300.webp" type="image/webp" />
          <img
          decoding="async"
          loading="lazy"
          width="300"
          height="300"
          src="/images/jaxeadv-logo-complete-and-transparent-300x300.png"
          alt="JAX ADV logo"
          sizes="(max-width: 300px) 100vw, 300px"
          class="flex m-auto pt-16"
          />
        </picture>
      </a>
      <a href="http://jaxeadv.com/barbuttons/">
        <picture class="contents">
          <source srcset="/images/barbuttons-on-gs-qbqkj0ewprszt270pnzzqqd78m64r0m0tc6zqls3nw.webp" type="image/webp" />
          <img width="400" height="270"
          decoding="async"
          src="/images/barbuttons-on-gs-qbqkj0ewprszt270pnzzqqd78m64r0m0tc6zqls3nw.jpg"
          title="barbuttons on gs"
          alt="barbuttons on gs"
          loading="lazy"
          class="flex m-auto pt-16"
          />
        </picture>
      </a>
      <p
        class="font-arial text-[17px] font-semibold text-[#A9A9A9] text-center pt-8"
      >
        BarButtons are a tiny bluetooth keyboard geared towards controlling map
        based motorcycle navigation, also controls Rally Navigator Roadbook
        Reader.
      </p>
      <p class="text-[22px] font-bold text-[#FF0000] hover:underline pt-8">
        <a href="https://jaxeadv.com/barbuttons/"> Bar Buttons </a>
      </p>
    </div>
  </section>
  <section class="my-8 mx-auto max-w-[1400px]">
    <FeaturesBanner />
    <PartnersSmall />
    <RallyLogoDownload link-text="Download Rally Navigator" />
  </section>
</template>

<script>
import YouTubeEmbed from './YouTubeEmbed.vue';
import FeaturesBanner from './FeaturesBanner.vue';
import PartnersSmall from './PartnersSmall.vue';
import RallyLogoDownload from './RallyLogoDownload.vue';

export default {
  name: 'MobileRoadbookReader',
  components: {
    YouTubeEmbed,
    FeaturesBanner,
    RallyLogoDownload,
    PartnersSmall,
  },
};
</script>

<style scoped></style>
